/* eslint @typescript-eslint/no-redundant-type-constituents: 0 */
import { IntlMessageFormat } from 'intl-messageformat';

const _new_on_goafrica_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Nouveau sur Go Africa ?' }],
    'fr',
);

const _new_on_goafrica_en = new IntlMessageFormat(
    [{ type: 0, value: 'New to Go Africa?' }],
    'en',
);

export function new_on_goafrica(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _new_on_goafrica_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _new_on_goafrica_en.format(args) as unknown as string;
    }

    return _new_on_goafrica_fr.format(args) as unknown as string;
}

const _register_for_free_fr = new IntlMessageFormat(
    [{ type: 0, value: "S'inscrire gratuitement" }],
    'fr',
);

const _register_for_free_en = new IntlMessageFormat(
    [{ type: 0, value: 'Register for free' }],
    'en',
);

export function register_for_free(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _register_for_free_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _register_for_free_en.format(args) as unknown as string;
    }

    return _register_for_free_fr.format(args) as unknown as string;
}

const _to_login_fr = new IntlMessageFormat([{ type: 0, value: 'Se connecter' }], 'fr');

const _to_login_en = new IntlMessageFormat([{ type: 0, value: 'Log in' }], 'en');

export function to_login(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _to_login_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _to_login_en.format(args) as unknown as string;
    }

    return _to_login_fr.format(args) as unknown as string;
}

const _forgot_your_password_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Mot de passe oublié ?' }],
    'fr',
);

const _forgot_your_password_en = new IntlMessageFormat(
    [{ type: 0, value: 'Forgot your password?' }],
    'en',
);

export function forgot_your_password(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _forgot_your_password_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _forgot_your_password_en.format(args) as unknown as string;
    }

    return _forgot_your_password_fr.format(args) as unknown as string;
}

const _label_email_fr = new IntlMessageFormat([{ type: 0, value: 'Email' }], 'fr');

const _label_email_en = new IntlMessageFormat([{ type: 0, value: 'Email' }], 'en');

export function label_email(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _label_email_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _label_email_en.format(args) as unknown as string;
    }

    return _label_email_fr.format(args) as unknown as string;
}

const _label_password_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Mot de passe' }],
    'fr',
);

const _label_password_en = new IntlMessageFormat([{ type: 0, value: 'Password' }], 'en');

export function label_password(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _label_password_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _label_password_en.format(args) as unknown as string;
    }

    return _label_password_fr.format(args) as unknown as string;
}

const _submitting_text_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Connexion en cours...' }],
    'fr',
);

const _submitting_text_en = new IntlMessageFormat(
    [{ type: 0, value: 'Logging in...' }],
    'en',
);

export function submitting_text(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _submitting_text_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _submitting_text_en.format(args) as unknown as string;
    }

    return _submitting_text_fr.format(args) as unknown as string;
}

const _submit_text_fr = new IntlMessageFormat([{ type: 0, value: 'Se connecter' }], 'fr');

const _submit_text_en = new IntlMessageFormat([{ type: 0, value: 'Log in' }], 'en');

export function submit_text(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _submit_text_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _submit_text_en.format(args) as unknown as string;
    }

    return _submit_text_fr.format(args) as unknown as string;
}
